import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BookingProvider } from "@/components/BookingDialog";
import PageViewTracker from "@/components/PageViewTracker";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/admin/AdminLayout";
import AdminOverview from "@/admin/AdminOverview";
import AdminBookings from "@/admin/AdminBookings";
import AdminContacts from "@/admin/AdminContacts";
import AdminPoll from "@/admin/AdminPoll";
import AdminBlog from "@/admin/AdminBlog";
import AdminBlogEditor from "@/admin/AdminBlogEditor";
import AdminAnalytics from "@/admin/AdminAnalytics";
import AdminDigest from "@/admin/AdminDigest";
import AdminMakeupWaitlist from "@/admin/AdminMakeupWaitlist";
import AdminLoyalty from "@/admin/AdminLoyalty";
import AdminGiftCards from "@/admin/AdminGiftCards";
import { AuthProvider } from "@/lib/auth";
import { installLocalBusinessSchema } from "@/lib/seo";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously — must run before any /me checks.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<BookingShell><Home /></BookingShell>} />
        <Route path="/blog" element={<BookingShell><Blog /></BookingShell>} />
        <Route path="/blog/:slug" element={<BookingShell><BlogPost /></BookingShell>} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="poll" element={<AdminPoll />} />
          <Route path="makeup-waitlist" element={<AdminMakeupWaitlist />} />
          <Route path="loyalty" element={<AdminLoyalty />} />
          <Route path="gift-cards" element={<AdminGiftCards />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="blog/new" element={<AdminBlogEditor />} />
          <Route path="blog/:slug/edit" element={<AdminBlogEditor />} />
          <Route path="digest" element={<AdminDigest />} />
          <Route path="analytics" element={<AdminAnalytics />} />
        </Route>
      </Routes>
    </>
  );
}

// BookingProvider only wraps public marketing routes (admin doesn't need it)
function BookingShell({ children }) {
  return <BookingProvider>{children}</BookingProvider>;
}

function App() {
  useEffect(() => {
    installLocalBusinessSchema();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
